import React, { useEffect, useState } from "react";
import { InputLoginV2 } from "../../components/input/Input";
import { InputGroupLoginV2 } from "../../components/inputGroup/InputGroup";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  postLoginSuccess,
  postLoginId,
  postClientOtpData,
} from "../../redux/slices/loginSlice";
import { Icon } from "antd";
import "./ResetPasswordV2.css";
import { Button } from "../../components/button/Button";
import DASHBOARD_API from "../../apis/dashboard.api";
import NewLoader from "../../components/styled-components/loader/NewLoader";

const ResetPasswordV2 = ({ token, setResetSuccess, otpRes }) => {
  const location = useLocation();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [apiError, setApiError] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const validatePassword = (pwd) => {
    if (!pwd) return "Password is required";
    if (pwd.length < 8) return "Password must be at least 8 characters";
    return "";
  };

  const validateConfirmPassword = (pwd, confirmPwd) => {
    if (!confirmPwd) return "Please confirm your password";
    if (pwd !== confirmPwd) return "Passwords do not match";
    return "";
  };

  const isFormValid = () => {
    const passwordError = validatePassword(password);
    const confirmPasswordError = validateConfirmPassword(
      password,
      confirmPassword
    );
    const validationErrors = {
      password: passwordError,
      confirmPassword: confirmPasswordError,
    };
    setErrors(validationErrors);
    return !passwordError && !confirmPasswordError;
  };

  const handleResetPassword = async () => {
    if (!isFormValid()) return;
    setLoading(true);
    setApiError("");

    const body = {
      password: password,
      confirmPassword: confirmPassword, // or token if stored in state
    };

    try {
      const res = await DASHBOARD_API.authResetPassword(token, body);

      if (!res || res.status !== 200) {
        throw new Error((res && res.message) || "Failed to reset password");
      }
      handleOtpResData(otpRes);
      console.log("Password reset successful");
      setResetSuccess(true);
    } catch (error) {
      setApiError(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = () => {
    const passwordError = validatePassword(password);
    const confirmPasswordError = validateConfirmPassword(
      password,
      confirmPassword
    );
    return !passwordError && !confirmPasswordError;
  };
  const inactiveRoles = ["inActive financial adviser client", "inActive Financial Advisor", "inactiveClient"]

  const handleOtpResData = (otpRes) => {
    let outputObj = {};
    if (otpRes.access_token) {
      dispatch(postLoginSuccess(otpRes));

      if (otpRes.user.roles) {
        const loginRole = otpRes.user.roles;
        if (loginRole.test111) {
          localStorage.setItem("role", JSON.stringify(loginRole.test111.name));
        } else if (loginRole.protrustee) {
          localStorage.setItem(
            "role",
            JSON.stringify(loginRole.protrustee.name)
          );
        } else if (loginRole.superAdmin) {
          localStorage.setItem(
            "role",
            JSON.stringify(loginRole.superAdmin.name)
          );
        } else {
          let recursive = (obj, name) => {
            for (let key in obj) {
              if (typeof obj[key] == "object") {
                recursive(obj[key], name + "_" + key);
              } else {
                outputObj[key] = obj[key];
              }
            }
          };
          recursive(loginRole, "loginRole");
          localStorage.setItem("role", JSON.stringify(outputObj.name));
        }
      }
      localStorage.setItem("userData", JSON.stringify(otpRes.user));
      localStorage.setItem("User", otpRes.user.name);
      if (otpRes.user.image !== null) {
        localStorage.setItem("profile", otpRes.user.image);
      }
      localStorage.setItem("userName", otpRes.user.userName);
      dispatch(postLoginId(otpRes.id));
      localStorage.setItem("userLoginToken", otpRes.access_token);

      if (otpRes.user.permissions) {
        let permissions = otpRes.user.permissions;
        const namesArray = Object.values(permissions).map(
          (permission) => permission.name
        );
        localStorage.setItem("permissionState", JSON.stringify(namesArray));

        // dispatch(postPermissionsSuccess(namesArray));
      }

      if (otpRes.access_token) {
        setLoading(true);
        console.log("here in getting delegateusers");
        let newData = [];
        setLoading(false);

        if (
          location.state &&
          location.state.from &&
          location.state.from.pathname
        ) {
          history.push({
            pathname: location.state.from.pathname,
            state: { from: location.state.from },
            PathExact: location.PathExact,
          });
        } else {
          if (newData.length > 0) {
            // history.push("/dashboard");
          } else {
            if (inactiveRoles.includes(outputObj.name)) {
              history.push("/payment");
            } else {
              history.push("/questioner");
            }
          }
        }

        dispatch(postClientOtpData({}));
      }
    }
  };

  return (
    <div className="reset-pass-wrapper">
      <div className="reset-pass-cardV2 border">
        <h2 className="reset-pass-headingV2">Reset Your Password</h2>
        <p className="reset-pass-sub-headerV2">
          Your new password must be different to previously used passwords.
        </p>
        <div className="reset-pass-form">
          <InputGroupLoginV2>
            <label className="reset-pass-label">New Password</label>
            <div className="reset-pass-input-wrapper">
              <InputLoginV2
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors({ ...errors, password: "" });
                }}
                className="reset-pass-input"
              />
              <Icon
                type={showPassword ? "eye-invisible" : "eye"}
                className="reset-pass-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            {errors.password && (
              <div className="reset-pass-errorV2">{errors.password}</div>
            )}
          </InputGroupLoginV2>

          <InputGroupLoginV2>
            <label className="reset-pass-label">Confirm Password</label>
            <div className="reset-pass-input-wrapper">
              <InputLoginV2
                id="confirm-password"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                name="confirm-password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setErrors({ ...errors, confirmPassword: "" });
                }}
                className="reset-pass-input"
              />
              <Icon
                type={showConfirmPassword ? "eye-invisible" : "eye"}
                className="reset-pass-icon"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              />
            </div>
            {errors.confirmPassword && (
              <div className="reset-pass-errorV2">{errors.confirmPassword}</div>
            )}
          </InputGroupLoginV2>

          {apiError && <div className="reset-pass-errorV2">{apiError}</div>}
          <Button
            className="reset-pass-button"
            style={{
              background: "#2A3DA3",
              borderRadius: "8px",
            //   opacity: canSubmit() ? 1 : 0.5,
            //   cursor: canSubmit() ? "pointer" : "not-allowed",
            }}
            // disabled={!canSubmit() || loading}
            onClick={handleResetPassword}
          >
            {loading ? "Processing..." : "Reset Password"}
          </Button>
        </div>
      </div>
      <NewLoader isLoading={loading}/>
    </div>
  );
};

export default ResetPasswordV2;